import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost } from './httpCommon/appAxios.service';
import {
  MARKETPLACE_BREEDER_PAYMENT_TRANSACTION_ENDPOINTS,
} from '../constants/apiEndpoints';
import { MarketPlaceBreederPaymentTransaction } from '../types/interfaces/marketPlace.interfaces';
import { ODataParams, StandardParams } from '../types/interfaces/apiParams.interfaces';

export const getMarketplaceBreederPaymentTransactions = (
  params?: StandardParams,
): Promise<AxiosResponse<MarketPlaceBreederPaymentTransaction[]>> => {
  return appContextGet(MARKETPLACE_BREEDER_PAYMENT_TRANSACTION_ENDPOINTS.BASE, params);
};

export const getMarketplaceBreederPaymentTransactionById = (
  id: number,
  params?: StandardParams,
): Promise<AxiosResponse<MarketPlaceBreederPaymentTransaction>> => {
  return appContextGet(`${MARKETPLACE_BREEDER_PAYMENT_TRANSACTION_ENDPOINTS.BASE}/${id}`, params);
};

export const markBreederPaymentTransactionAsPaid = (breederPaymentTransactionId: number): Promise<AxiosResponse<unknown>> => {
  return appContextPost(
    `${MARKETPLACE_BREEDER_PAYMENT_TRANSACTION_ENDPOINTS.BASE}/${breederPaymentTransactionId}${MARKETPLACE_BREEDER_PAYMENT_TRANSACTION_ENDPOINTS.MARK_AS_PAID}`,
    {},
  );
};

export const downloadBreederPaymentHistoryReport = (
  payload?: {},
  query?: ODataParams,
): Promise<AxiosResponse<any>> => {
  return appContextPost(
    `${MARKETPLACE_BREEDER_PAYMENT_TRANSACTION_ENDPOINTS.BASE}${MARKETPLACE_BREEDER_PAYMENT_TRANSACTION_ENDPOINTS.EXPORT}`,
    payload,
    query,
    { responseType: 'blob' },
  );
};
